import Component from 'vue-class-component';
import './tabs-menu.scss'
import { ReactiveVue } from '@skinsoft/reactive-vue';

export const SELECTED_TAB_CHANGE_EVENT = 'selected-item-changed'

@Component({
    props: ['titles', 'selectedIndex'],
    template: require('./tabs-menu.html')
})
export class TabsMenu extends ReactiveVue {
    private titles: string[]
    private selectedIndex: number

    private isSelected(index: number) {
        return index === this.selectedIndex
    }

    private onTabClicked(index: number) {
        if(index !== this.selectedIndex) {
            this.$emit(SELECTED_TAB_CHANGE_EVENT, index)
        }
    }
}